module.exports = __webpack_public_path__ + "img/pv2slt.898b16df.jpg";